<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 md6>
        <material-card
          title="Ubah Password"
          text="silahkan ubah password anda disini!"
          elevation-24
        >
          <v-form>
            <v-container>
              <v-layout column>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    v-model="password"
                    :rules="passRules"
                    prepend-icon="lock_open"
                    name="password"
                    required
                    label="Password Lama"
                    id="oldPassword"
                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                    :type="showPassword ? 'text' : 'password'"
                    counter
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                  <v-text-field
                    v-model="newPassword"
                    :rules="newPassRules"
                    prepend-icon="lock"
                    name="newPassword"
                    required
                    label="Password Baru"
                    id="newPassword"
                    :append-icon="showNewPassword ? 'visibility' : 'visibility_off'"
                    :type="showNewPassword ? 'text' : 'password'"
                    counter
                    @click:append="showNewPassword = !showNewPassword"
                    @keypress.enter="changePassword"
                  ></v-text-field>
                  <!-- <v-spacer/> -->
                  <v-btn
                    :loading="loading"
                    block
                    color="secondary"
                    :disabled="!valid || loading"
                    @click="changePassword"
                    class="mx-0 font-weight-light"
                  >
                    Ubah Password
                    <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                    </span>
                  </v-btn>
                </v-form>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      loader: null,
      valid: false,

      password: "",
      passRules: [
        v => !!v || "Password tidak boleh kosong",
        v => (v && v.length >= 5) || "Minimal 5 karakter"
      ],

      newPassword: "",
      newPassRules: [
        v => !!v || "Password tidak boleh kosong",
        v => (v && v.length >= 5) || "Minimal 5 karakter"
      ],

      showPassword: false,
      showNewPassword: false
    };
  },

  methods: {
    ...mapMutations("app", ["setAuth", "setAlert"]),

    changePassword() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      if (this.$refs.form.validate()) {
        this.loader = "loading";
        const l = this.loader;
        this[l] = !this[l];

        let formData = {
          password: this.password,
          new_password: this.newPassword
        };

        axios
          .patch("/update-password", formData)
          .then(response => {
            this.setAlert({
              status: true,
              text: "Password berhasil di ubah",
              type: "success"
            });

            this.$router.push("/dashboard");
          })
          .catch(error => {
            console.log(error.response);

            this.setAlert({
              status: true,
              text: error.response.data.message,
              type: "error"
            });

            this[l] = false;
            this.loader = null;
          });
      }
    }
  }
};
</script>
